// extracted by mini-css-extract-plugin
export default {"wrapper":"Terms_wrapper__8YIR6","inner":"Terms_inner__kTTWF","title":"Terms_title__zJCXw","section":"Terms_section__65C1A"};